import { tryCatchHelper } from '../../../../helpers';
import {
  ACTIVO_ACTIVIDADES_EXTRAS,
  ALL_ACTIVIDADES_EXTRAS,
  LOADING_ALL_ACTIVIDADES_EXTRAS,
} from './ActividadesExtrasReducer';
import {
  allActividadesExtrasService,
  deleteActividadesExtrasService,
  oneActividadesExtrasService,
  saveActividadesExtrasService,
} from './ActividadesExtrasService';

export const allActividadesExtrasAction = async (dispatch, params) => {
  try {
    dispatch({ type: LOADING_ALL_ACTIVIDADES_EXTRAS, payload: true });
    const res = await allActividadesExtrasService(params);
    dispatch({ type: ALL_ACTIVIDADES_EXTRAS, payload: res.data });
    dispatch({ type: LOADING_ALL_ACTIVIDADES_EXTRAS, payload: false });
    return res.data;
  } catch (e) {
    dispatch({ type: LOADING_ALL_ACTIVIDADES_EXTRAS, payload: false });
    tryCatchHelper(e);
    return false;
  }
};

export const saveActividadesExtrasAction = async (
  { dispatch, notify },
  id,
  data,
  params,
) => {
  try {
    const res = await saveActividadesExtrasService(id, data);
    notify(res.data.message);
    await allActividadesExtrasAction(dispatch, params);
    return res.data;
  } catch (e) {
    tryCatchHelper({ e, notify });
    return false;
  }
};

export const setActivoActividadesExtrasAction = async (dispatch, data) => {
  dispatch({ type: ACTIVO_ACTIVIDADES_EXTRAS, payload: data });
};

export const oneActividadesExtrasAction = async (dispatch, id) => {
  try {
    const res = await oneActividadesExtrasService(id);
    await setActivoActividadesExtrasAction(dispatch, res.data.data);
    return res.data;
  } catch (e) {
    tryCatchHelper(e);
    return false;
  }
};

export const deleteActividadesExtrasAction = async (
  { dispatch, notify },
  id,
  params,
) => {
  try {
    const res = await deleteActividadesExtrasService(id);
    notify(res.data.message);
    await setActivoActividadesExtrasAction(dispatch, null);
    await allActividadesExtrasAction(dispatch, params);
    return true;
  } catch (e) {
    tryCatchHelper({ e, notify });
    return false;
  }
};
